import Button from 'apollo-react/components/Button';
import _ from 'lodash';
import qs from 'query-string';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import NavigateLinkCell from './FindPage/NavigateLinkCell';
import DefaultPageLayout from '../components/DefaultPageLayout';
import SavedSearchesTable from '../components/SavedSearchesTable';
import { GET_ADMIN_REPOSITORIES_ENDPOINT } from '../constants/RepositoryConfigurationConstants';
import { REPOSITORY_CONFIGURATION } from '../constants/Urls';
import { useTranslation } from '../custom-hooks/useTranslation';
import { getIsAddRepositoryButtonEnabled } from '../selectors/DocumentRepositorySelectors';
import { getUITA } from '../utils/commonUtils';

const RepositoryListPage = ({ location }) => {
  const translateString = useTranslation();
  const { entityName, searchName } = qs.parse(location.search);

  const pageTitle = searchName || translateString('Document Repositories');

  const isAddRepositoryEnabled = useSelector((state) =>
    getIsAddRepositoryButtonEnabled(state, { entityName, searchName })
  );

  useEffect(() => {
    document.title = pageTitle;
  }, [pageTitle]);

  const TableActions = () =>
    isAddRepositoryEnabled ? (
      <Link
        to={{
          pathname: REPOSITORY_CONFIGURATION,
          search: qs.stringify({ isNew: true }),
        }}
        ui-ta={getUITA('add-new-record')}
      >
        <Button color="secondary" variant="secondary">
          {translateString('Add Repository')}
        </Button>
      </Link>
    ) : null;

  if (_.isNil(entityName)) {
    return (
      <DefaultPageLayout>{translateString('Please provide an entity name.')}</DefaultPageLayout>
    );
  }

  return (
    <DefaultPageLayout pageTitle={pageTitle} removeHeaderMargin={isAddRepositoryEnabled}>
      <SavedSearchesTable
        showSearchSelector={false}
        customCell={NavigateLinkCell.forUrl(REPOSITORY_CONFIGURATION)}
        entityName={entityName}
        enableSorting
        initialSearchName={searchName}
        rowsPerPageOptions={[10, 25, 50]}
        tableActions={TableActions}
        title={translateString('Records')}
        customEndpointName={GET_ADMIN_REPOSITORIES_ENDPOINT}
        showFilters
      />
    </DefaultPageLayout>
  );
};

export default RepositoryListPage;
